/* @flow */

export const REGISTER_APM_ENDPOINT = '/services/apm';
export const APM_EVENT_TYPE = 'INDICATOR_CLICKED';

export const marketplaceApmParams = {
  eventType: 'MARKETPLACE_QUERY',
};



// WEBPACK FOOTER //
// ./src/app/modules/tracking/constants.js